module.exports = __webpack_public_path__ + "static/media/DONT SOOT FILMS 2.5f56d08b.JPG";